// import {getToken} from "@/utils/auth";
import Vue from 'vue'
import {downloadByFileId} from "@/api/download_file";

// 格式化文件大小
export function formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

export function uploadFile(file, options = {file_field: 'upload_file', maxSize: 5, appendData: {}}, cb) {
    const formData = new FormData()

    // const maxSize = 5;//
    const fileSize = file.size || 0
    if (fileSize > options.maxSize * 1024 * 1024) {
        alert(`文件大小超过${options.maxSize}M`)
        return {success: false, message: `文件大小超过${options.maxSize}M`};
    }

    formData.append(options.file_field, file.raw)
    formData.append('file_name', file.name)
    // 其他参数
    if (options.appendData) {
        formData.append('file_type', options.appendData.file_type || 'file')
        formData.append('folder', options.appendData.file_type || 'other')
    }


    let uploadStartTime;
    uploadStartTime = Date.now();
    // const token = getToken()
    return new Promise(resolve => {
        Vue.axios.post('/api/upload/file_uploader', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }, onUploadProgress: (progressEvent) => {
                if (progressEvent.lengthComputable) {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);

                    // 计算上传速度
                    const elapsedTime = (Date.now() - uploadStartTime) / 1000; // 秒
                    const speed = progressEvent.loaded / elapsedTime; // 字节/秒
                    const speedFormat = `${formatFileSize(speed)}/s`

                    // 更新进度条
                    // eslint-disable-next-line no-console
                    console.log(`上传进度：${percentCompleted}%`)
                    // eslint-disable-next-line no-console
                    console.log(`上传速递：${speedFormat}`)

                    // 更新文件状态
                    if (typeof cb === 'function') cb(file.name, {percentCompleted, speed, speedFormat});
                }
            }
        }).then((resp) => {

            resolve(resp)
        })
    })

}

import FileSaver from 'file-saver'

/**
 * 文件下载（通过文件id）
 * @param id
 * @param name
 * @param cb
 * @returns {Promise<void>}
 */
export async function downLoadFile(id, name, cb) {
    try {
        let isFileSaverSupported = !!new Blob()
        if (isFileSaverSupported) {
            const response = await downloadByFileId({id})
            const data = response.data
            const contentType = response.headers['content-type']
            const blob = new Blob([data], {type: contentType})
            FileSaver.saveAs(blob, decodeURI(name), {autoBom: true})
            // this.$refs[`refExportLink${id}`].loadingDownload = false;
            if (typeof cb === 'function') {
                cb(response)
            }
        } else {
            alert('浏览器不支持导出文件')
        }
    } catch (e) {
        alert('导出异常，请联系管理员')
        // eslint-disable-next-line no-console
        console.log('downLoadFile err:',e)
    }
}
